/**
 * Created by katarinababic on 23.6.25.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { WeaviateSuggestionResult, WeaviateSuggestionResultApi } from '../../Model/Suggestions/WeaviateSuggestionResult';
import { HomeScreenSuggestionItem } from './HomeScreenSuggestionItem';
import { useRootStore } from '../../Store/useRootStore';
import { useLocalized } from '../../Hooks/useLocalized';
import { useLocalizedImage } from '../../Hooks/useLocalizedMedia';
import { useTrans } from '../../Store/System/LocalizationStore';
import { useNavigate } from 'react-router-dom';
import { ActivityWorkoutEntry } from '../../Model/Explore/ActivityWorkoutEntry';
import { StringUtils } from '../../Utils/StringUtils';
import { useSecondaryText } from '../../Utils/ExploreUtils';
import { getMediaLargeOrMediumOrSmallest } from '../../Model/Media/Media';

export type HomeScreenMentalSuggestionItemProps = {
  suggestion: WeaviateSuggestionResult;
  onRefresh?: () => void;
};

export const HomeScreenMentalSuggestionItem: React.FC<HomeScreenMentalSuggestionItemProps> = observer(
  ({ suggestion, onRefresh }) => {
    const { authentication, analytics } = useRootStore();
    const navigate = useNavigate();
    const { t } = useTrans();
    const entryName = useLocalized(suggestion.content?.name);
    const activityName = useLocalized((suggestion.content as ActivityWorkoutEntry)?.activity?.name);

    const [loading, setLoading] = useState(false);

    const athlete = authentication.athlete;
    const entry = suggestion.content;
    const entryImage = useLocalizedImage(entry && 'backgroundImage' in entry ? entry?.images : undefined);
    const imageUrl = entryImage ? getMediaLargeOrMediumOrSmallest(entryImage) : undefined;
    const typeTag =
      entry && 'backgroundImage' in entry
        ? entry.type === 'activityWorkout'
          ? activityName
          : t(`coach_tab.suggestions.typeTag.${entry?.type}`)
        : undefined;
    const imageSrc = imageUrl || require('../../Assets/Images/logo.png');
    const title = entryName ? StringUtils.shortenString(entryName, 40) : '';

    const handlePress = React.useCallback(() => {
      if (entry) {
        analytics.logEvent('coachTabMentalSuggestion', { entryId: entry.id });
        navigate(`/mental-health/${entry.id}`);
      }
    }, [analytics, entry, navigate]);

    const refreshSuggestion = React.useCallback(() => {
      if (athlete) {
        setLoading(true);
        analytics.logEvent('refresh_workout_suggestion', {
          ...suggestion.tags.reduce((acc, tag) => ({ ...acc, [tag]: 1 }), {}),
          category: 'mental',
          contentId: suggestion.contentId,
          contentType: suggestion.contentType,
        });
        WeaviateSuggestionResultApi
          .refresh(suggestion.category)
          .then(() => {
            onRefresh?.();
          })
          .catch((error) => {
            console.error('Failed to refresh mental suggestion:', error);
          })
          .finally(() => setLoading(false));
      }
    }, [suggestion, athlete, analytics, onRefresh]);

    return (
      <HomeScreenSuggestionItem
        image={imageSrc as string}
        onPress={handlePress}
        title={title}
        secondaryText={useSecondaryText(entry)}
        loading={loading}
        onRefresh={refreshSuggestion}
        refreshDisabled={loading}
        locked={false}
        onboardingSection="mentalHealth"
        suggestionType="mentalHealth"
        typeTag={typeTag}
      />
    );
  },
);
